import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DataTable, Spinner } from '@dixa/lib-shared-habla';
import NO_RESULT_IMAGE from 'images/no-search-results.png';
import styles from '../bansTable.module.scss';
import { subTableColumns, tableColumns } from './bannedUsersColumns';
const Message = (props) => {
    return (_jsxs("div", Object.assign({ className: styles.messageContainer }, { children: [props.before && (_jsx("div", Object.assign({ className: styles.messageBefore }, { children: props.before }))), _jsx("div", Object.assign({ className: styles.messageText }, { children: props.text })), props.after && _jsx("div", Object.assign({ className: styles.messageAfter }, { children: props.after }))] })));
};
const LOADING_MESSAGE = (_jsx(Message, { text: "Getting banned users ...", before: _jsx(Spinner, { size: 32 }) }));
const NO_BANNED_USERS_MESSAGE = (_jsx(Message, { text: "There are no banned users.", before: _jsx("img", { className: styles.messageImage, src: NO_RESULT_IMAGE, alt: "No result image" }) }));
const ERROR_MESSAGE = _jsx(Message, { text: "Error" });
export function BannedUsersTable({ asyncStatus, hasPreviousPage, hasNextPage, previousPage, nextPage, refreshItems, items, }) {
    if (asyncStatus === 'loading') {
        return LOADING_MESSAGE;
    }
    if (asyncStatus === 'failed') {
        return ERROR_MESSAGE;
    }
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return NO_BANNED_USERS_MESSAGE;
    }
    return (_jsx(DataTable, { columns: tableColumns(refreshItems), data: items, subTableColumns: subTableColumns, subTableDataSelector: ({ bans }) => bans, paginationProps: {
            previousButtonDisabled: !hasPreviousPage,
            nextButtonDisabled: !hasNextPage,
            previousButtonClick: previousPage,
            nextButtonClick: nextPage,
        } }));
}
